// ---------------------------------------------
// Custom Logo Positioning - DeSight Shopify Theme
// Desktop-only: logo is hidden on mobile, skip all observers.
// ---------------------------------------------

import { debounce } from '../utils/helpers.js';

export class CustomLogoPositioning {
  constructor() {
    this.logoImage = null;
    this.announcementBar = null;
    this.header = null;
    this.logoWidth = 150;
  }

  init() {
    this.logoImage = document.querySelector('.custom-logo__image');

    if (!this.logoImage) {
      setTimeout(() => this.init(), 100);
      return;
    }

    this.announcementBar = document.querySelector('.announcement-bar');
    this.header = document.querySelector('.header');

    this.updatePositioning();

    const debouncedUpdate = debounce(() => this.updatePositioning(), 100);
    window.addEventListener('resize', debouncedUpdate, { passive: true });
  }

  updatePositioning() {
    if (!this.logoImage) return;

    const logoWidth = (this.logoImage.offsetWidth > 10) ? this.logoImage.offsetWidth : 120;

    document.documentElement.style.setProperty('--custom-logo-width', `${logoWidth}px`);

    const paddingLeft = 140;
    document.documentElement.style.setProperty('--custom-logo-padding-left', `${paddingLeft}px`);
  }
}

export function initCustomLogo() {
  if (!document.querySelector('.custom-logo__image')) return;
  const instance = new CustomLogoPositioning();
  instance.init();
}
